import React, { useContext, useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Button, Divider, SimpleGrid, Skeleton, Text } from "@chakra-ui/react";
import { useQuery } from "react-query";
import { Image } from "@chakra-ui/react";
import users_icon from '../../assets/svgs/users.svg'
import products_icon from '../../assets/svgs/products.svg'
import pending_orders from '../../assets/svgs/pending_orders.svg'
import completed_orders from '../../assets/svgs/completed_orders.svg'
import server_down_icon from '../../assets/svgs/server_down.svg'
import { getStats } from "../../services/products";
import { AdminContext } from "../../contexts/AdminContext";

export default function Dashboard() {
  const { admin } = useContext(AdminContext)

  const token = `bearer ${admin.token}`
  const stats = useQuery('stats', () => getStats(token))

  useEffect(() => {
    document.title = "Dashboard";
  }, []);

  return (
    <React.Fragment>
      <DashboardLayout>
        <Box mt='20px' w='full' maxW='80rem'>
          {stats.isLoading && 
            <SimpleGrid columns={[1, 2, 2, 4]} spacing={5}>
              {[1, 2, 3, 4].map((num: number) => (
                <StatsCardSkeleton
                  key={num}
                />
              ))}
            </SimpleGrid>
          }

          {stats.data &&
            <SimpleGrid columns={[1, 2, 2, 4]} spacing={5}>
              <StatsCard
                img={users_icon}
                stat="Total Users"
                result={stats.data.total_users}
              />

              <StatsCard
                img={products_icon}
                stat="Total Products"
                result={stats.data.total_products}
              />

              <StatsCard
                img={pending_orders}
                stat="Total Orders Pending"
                result={stats.data.total_placed_orders}
              />

              <StatsCard
                img={completed_orders}
                stat="Total Orders Completed"
                result={stats.data.total_completed_orders}
              />
            </SimpleGrid>
          }

          {stats.isError &&
            <Box textAlign='center' mt='10'>
              <Box>
                <Image
                  w='300px'
                  h='300px'
                  mx='auto'
                  src={server_down_icon}
                />
              </Box>

              <Text
                p='2' color='red.500'
                fontWeight='semibold'
              >
                Failed to fetch Stats
              </Text>

              <Button colorScheme='green' size='lg' onClick={() => stats.refetch()}>
                Try again
              </Button>
            </Box>
          }
        </Box>
      </DashboardLayout>
    </React.Fragment>
  )
}

function StatsCard({ stat, result, img }: { stat: string, result: string, img: any }){
  return (
    <Box shadow='md' p='5' w='full' border='2px solid #E9E5E5' rounded='20px'>
      <Box>
        <Image
          w='200px'
          h='200px'
          mx='auto'
          src={img}
        />
      </Box>

      <Divider
        border='1px'
        mt={4}
      />

      <Box mt={2} textAlign='center'>
        <Text
          fontSize='lg'
          fontWeight='semibold'
        >
          {stat}
        </Text>

        <Text
          mt={1}
          fontSize='2xl'
          fontWeight='bold'
        >
          {result}
        </Text>
      </Box>
    </Box>
  )
}

function StatsCardSkeleton(){
  return (
    <Box shadow='md' p='5' w='full' border='2px solid #E9E5E5' rounded='20px'>
      <Box>
        <Skeleton
          w='full'
          h='200px'
        />
      </Box>

      <Divider
        border='1px'
        mt={4}
      />

      <Box mt={4} textAlign='center'>
        <Skeleton
          rounded='md'
          w='150px'
          h='14px'
        />

        <Skeleton
          mt={3}
          rounded='md'
          w='100px'
          h='14px'
        />
      </Box>
    </Box>
  )
}